module.exports = __webpack_public_path__ + "static/img/huawei.2728f27e.png";